import React from 'react';
import { faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './Reviews.module.scss';
import { Review } from 'common/types/search';

interface Props {
  reviews_full?: Review[];
}

export const Reviews:React.FC<Props> = ({
  reviews_full = [],
}) => {
  return (
    <div className={styles.reviews_container}>
      {reviews_full.length > 0 ? (
        reviews_full.map((review: Review) => {
          const [year, month, day] = review.creation_date
            .split(" ")[0]
            .split("-");

          return (
            <div key={review.id} className={styles.review}>
              <div className={styles.heading}>
                <div className={styles.avatar_container}>
                  <img
                    className={styles.avatar}
                    src={review.user_profile_image_url}
                    alt="avatar"
                  />
                </div>
                <div className={styles.name_stars_container}>
                  <p className={styles.user_name}>{review.user_name}</p>
                  <div className={styles.review_stars}>
                    {Array.from({ length: review.rating_data.whole }).map(
                      (_, index) => (
                        <FontAwesomeIcon
                          key={index}
                          className={styles.full_star}
                          icon={faStar}
                        />
                      )
                    )}
                    {Array.from({ length: 5 - review.rating_data.whole }).map(
                      (_, index) => (
                        <FontAwesomeIcon
                          key={index}
                          className={styles.empty_star}
                          icon={faStar}
                        />
                      )
                    )}
                  </div>
                </div>
              </div>
              <div>
                <div className={styles.title_date_container}>
                  <p className={styles.review_title}>{review.title}</p>
                  <span className={styles.review_date}>
                    {`${day}.${month}.${year}`}
                  </span>
                </div>
                <div className={styles.review_comment}>
                  <div
                    dangerouslySetInnerHTML={{ __html: review.comment }}
                  ></div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className={styles.no_reviews}>No reviews</div>
      )}
    </div>
  );
};
